export const userData = {
    app_name: "Ortho Clinical Diagnostics",
    user_name: "Mia Johnson",
    account_name: "Penn Presbyterian",
    notification: [{
        count: 6,
        message: ""
    }],
    user_avatar: ""
}